import { render, staticRenderFns } from "./Category.vue?vue&type=template&id=04e4b4c7&scoped=true&"
import script from "./Category.vue?vue&type=script&lang=js&"
export * from "./Category.vue?vue&type=script&lang=js&"
import style0 from "./Category.vue?vue&type=style&index=0&id=04e4b4c7&lang=scss&scoped=true&"
import style1 from "./Category.vue?vue&type=style&index=1&id=04e4b4c7&scoped=true&lang=css&"
import style2 from "./Category.vue?vue&type=style&index=2&id=04e4b4c7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e4b4c7",
  null
  
)

export default component.exports